import { BadgeDollarSignIcon, CircleAlertIcon, MegaphoneIcon, SparklesIcon } from 'lucide-react';

import type { FeedInfo } from '../types';

const iconProps = {
  'aria-hidden': true,
  className: 'size-5'
} as const;

export const FeedIcon = ({ Type }: Pick<FeedInfo['symbol'], 'Type'>) => {
  switch (Type.replaceAll(/\s/g, '')) {
    case 'NewPrice':
      return <BadgeDollarSignIcon {...iconProps} />;
    case 'Alert':
      return <CircleAlertIcon {...iconProps} />;
    case 'System':
      return <MegaphoneIcon {...iconProps} />;
    default:
      return <SparklesIcon {...iconProps} />;
  }
};
